import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
var _excluded = ["marketIds", "regionIds", "isReady", "useNewAsync"];
import "core-js/modules/es.function.name.js";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context, _context2; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context = ownKeys(Object(t), !0)).call(_context, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context2 = ownKeys(Object(t))).call(_context2, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from "react";
import { SelectableNodeEnum } from "utils/Enums";
import AsyncSelect from "../AsyncSelect/AsyncSelect";
import { AsyncSelect as NewAsync } from "dashboard/BrokerHome/DealsViewPages/MyDealsMultiSelect";
import { jsx as _jsx } from "react/jsx-runtime";
function NeighborhoodSelect(_ref) {
  var _ref$marketIds = _ref.marketIds,
    marketIds = _ref$marketIds === void 0 ? null : _ref$marketIds,
    _ref$regionIds = _ref.regionIds,
    regionIds = _ref$regionIds === void 0 ? null : _ref$regionIds,
    _ref$isReady = _ref.isReady,
    isReady = _ref$isReady === void 0 ? null : _ref$isReady,
    useNewAsync = _ref.useNewAsync,
    rest = _objectWithoutProperties(_ref, _excluded);
  var extraParams = {};
  if (marketIds) {
    extraParams.marketIds = marketIds;
  }
  if (regionIds) {
    extraParams.regionIds = regionIds;
  }
  if (isReady) {
    extraParams.isReady = isReady;
  }
  var props = _objectSpread({
    nodeType: SelectableNodeEnum.NEIGHBORHOODS.name,
    extraParams: extraParams,
    placeholder: "Search for a Neighborhood"
  }, rest);
  if (useNewAsync) {
    return /*#__PURE__*/_jsx(NewAsync, _objectSpread({}, props));
  }
  return /*#__PURE__*/_jsx(AsyncSelect, _objectSpread({}, props));
}
export default NeighborhoodSelect;